var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongratsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1298_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 57C12.7775 57 0 44.2225 0 28.5C0 12.7775 12.7775 0 28.5 0C44.2225 0 57 12.7775 57 28.5C57 44.2225 44.2225 57 28.5 57ZM28.5 2.375C14.0837 2.375 2.375 14.0837 2.375 28.5C2.375 42.9163 14.0837 54.625 28.5 54.625C42.9163 54.625 54.625 42.9163 54.625 28.5C54.625 14.0837 42.9163 2.375 28.5 2.375Z",
    fill: "#30313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3414 37.3823C25.0327 37.3823 24.7239 37.2635 24.5102 37.026L16.7439 29.2598C16.2689 28.8085 16.2689 28.0485 16.7439 27.5735C17.2189 27.0985 17.9552 27.1223 18.4302 27.5735L25.3652 34.5085L39.9239 19.9498C40.3752 19.4985 41.1352 19.4985 41.6102 19.9498C42.0852 20.401 42.0614 21.161 41.6102 21.636L26.1964 37.0498C25.9827 37.2635 25.6739 37.406 25.3652 37.406L25.3414 37.3823Z",
    fill: "#30313A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1298_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsBlack);
export default __webpack_public_path__ + "static/media/congratsBlack.218a6a439174c099e1041e8dca913555.svg";
export { ForwardRef as ReactComponent };